import { Navigate } from "react-router-dom";
import { useAuth } from "@/store/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ role, roles, children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0f0f0f]" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 text-[#d4af37] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const allowed = roles || (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) {
    const home = ["admin", "receptionist"].includes(user.role) ? "/admin" : user.role === "barber" ? "/barber" : "/";
    return <Navigate to={home} replace />;
  }
  return children;
}
